import { ContentTypeTranslationMap } from '@/config/ContentType';
import i18n from '@/i18n';

const { t } = i18n.global;

export const getTranslatedTypeName = (contentType: string): string =>
  contentType && ContentTypeTranslationMap[contentType] ? t(ContentTypeTranslationMap[contentType]) : '';
